import React from "react";
import {Pagination} from "react-bootstrap";

function STCPaginationFirst(props){

    return(
        <Pagination.First
            style={props.style}
            className={props.className}
            onClick={props.onClick}
        >
            {props.children}
        </Pagination.First>
    )
}
export default STCPaginationFirst;
